import React from "react";
import { Routes,Route } from 'react-router-dom';
import Theme from '../Component/Theme';
import Contact from '../pages/Contact/Contact';
import Home from '../pages/Home/Home';
import About from '../pages/About/About';
import Projects from '../pages/Projects';
import NoPageFound from '../pages/NoPageFound';
import News from '../pages/Projects/News';
import Incrementer from '../pages/Projects/Incrementer';
import {Game} from '../pages/Projects/Game';
import Clock from '../pages/Projects/Clock';
import Jokes from '../pages/Projects/Jokes';
import Todo from '../pages/Projects/Todo';
import Boxshadow from '../pages/Projects/Boxshadow';
import Musicsystem from '../pages/Projects/Musicsystem';
import SlotM from '../pages/Projects/SlotM';

const AppRouter = () => {
  return (
    <Routes>
        <Route path="/" element={<Theme/>} >
              <Route index element={<Home/>}/>
              <Route path='about' element={<About/>}/>
              <Route path="contact" element={<Contact/>} />
              <Route path="project/" element={<Projects/>} >
              </Route>
              <Route path="newsapp" element={<News/>}></Route>
              <Route path="incrementer" element={<Incrementer/>}></Route>
              <Route path="game" element={<Game/>}></Route>
              <Route path="clock" element={<Clock/>}></Route>
              <Route path="jokesapp" element={<Jokes/>}></Route>
              <Route path="todo" element={<Todo/>}></Route>
              <Route path="boxshadowgenerator" element={<Boxshadow/>}></Route>
              <Route path="musicsystem" element={<Musicsystem/>}></Route>
              <Route path="slotmachinegame" element={<SlotM/>}></Route>               
              <Route path="*" element={<NoPageFound/>}/>
        </Route>
        
    </Routes>
  )
}

export default AppRouter
